import dayjs from 'dayjs'

export const isHolidaySeason = (date = dayjs()) => {
  const month = date.month() // 0 - январь, 11 - декабрь
  const day = date.date()

  //Показываем снегопад с 1 декабря по 15 января
  return month === 11 || (month === 0 && day <= 15)
}
